let viewgird = [
  //
  // ----------
  // 设备相关
  {
    path: '/Device',
    name: 'Device',
    component: () => import('@/views/device/device/Device.vue')
  },
  {
    path: '/Dev_ConnectCompDevice',
    name: 'Dev_ConnectCompDevice',
    component: () => import('@/views/device/device/Dev_ConnectCompDevice.vue')
  },
  {
    path: '/Dev_Device',
    name: 'Dev_Device',
    component: () => import('@/views/device/device/Dev_Device.vue')
  },
  {
    path: '/Dev_DeviceDetail',
    name: 'Dev_DeviceDetail',
    component: () => import('@/views/device/device/Dev_DeviceDetail.vue')
  },
  {
    path: '/Dev_DeviceDetailUpdate',
    name: 'Dev_DeviceDetailUpdate',
    component: () => import('@/views/device/device/Dev_DeviceDetailUpdate.vue')
  },
  {
    path: '/Dev_TelemetryGroup',
    name: 'Dev_TelemetryGroup',
    component: () => import('@/views/device/device/Dev_TelemetryGroup.vue')
  },
  {
    path: '/Dev_TelemetryGroupDetail',
    name: 'Dev_TelemetryGroupDetail',
    component: () => import('@/views/device/device/Dev_TelemetryGroupDetail.vue')
  },
  {
    path: '/Dev_DeviceType',
    name: 'Dev_DeviceType',
    component: () => import('@/views/device/device/Dev_DeviceType.vue')
  },
  {
    path: '/Dev_DeviceAlarmMsg',
    name: 'Dev_DeviceAlarmMsg',
    component: () => import('@/views/device/device/Dev_DeviceAlarmMsg.vue')
  },
  {
    path: '/Dev_Company',
    name: 'Dev_Company',
    component: () => import('@/views/device/device/Dev_Company.vue')
  },
  {
    path: '/Dev_UserRole',
    name: 'Dev_UserRole',
    component: () => import('@/views/device/device/Dev_UserRole.vue')
  },
  {
    path: '/Dev_RoleDeviceAuth',
    name: 'Dev_RoleDeviceAuth',
    component: () => import('@/views/device/device/Dev_RoleDeviceAuth.vue')
  },
  {
    path: '/Dev_FaultInfo',
    name: 'Dev_FaultInfo',
    component: () => import('@/views/device/device/Dev_FaultInfo.vue')
  },
  //
  // ----------
  // 报警
  {
    path: '/alarmlist',
    name: 'alarmlist',
    component: () => import('@/views/device/alarm/alarmlist.vue')
  },
  {
    path: '/Dev_Alarm',
    name: 'Dev_Alarm',
    component: () => import('@/views/device/alarm/Dev_Alarm.vue')
  },
  {
    path: '/Dev_AlarmLatest',
    name: 'Dev_AlarmLatest',
    component: () => import('@/views/device/alarm/Dev_AlarmLatest.vue')
  },
  {
    path: '/Dev_AlarmHistory',
    name: 'Dev_AlarmHistory',
    component: () => import('@/views/device/alarm/Dev_AlarmHistory.vue')
  },
  {
    path: '/Dev_AlarmMessage',
    name: 'Dev_AlarmMessage',
    component: () => import('@/views/device/alarm/Dev_AlarmMessage.vue')
  },
  {
    path: '/Dev_AlarmRuleEvent',
    name: 'Dev_AlarmRuleEvent',
    component: () => import('@/views/device/alarm/Dev_AlarmRuleEvent.vue')
  },
  {
    path: '/Dev_AlarmRule',
    name: 'Dev_AlarmRule',
    component: () => import('@/views/device/alarm/Dev_AlarmRule.vue')
  },
  {
    path: '/Dev_AlarmDetail',
    name: 'Dev_AlarmDetail',
    component: () => import('@/views/device/alarm/Dev_AlarmDetail.vue')
  },
  {
    path: '/Dev_AlarmList',
    name: 'Dev_AlarmList',
    component: () => import('@/views/device/alarm/Dev_AlarmList.vue')
  },
  {
    path: '/Dev_SwitchDevice',
    name: 'Dev_SwitchDevice',
    component: () => import('@/views/device/device/Dev_SwitchDevice.vue')
  },
  {
    path: '/Dev_SwitchLog',
    name: 'Dev_SwitchLog',
    component: () => import('@/views/device/device/Dev_SwitchLog.vue')
  },
  {
    path: '/Dev_SwitchEventLog',
    name: 'Dev_SwitchEventLog',
    component: () => import('@/views/device/device/Dev_SwitchEventLog.vue')
  },
  {
    path: '/Dev_Tmp',
    name: 'Dev_Tmp',
    component: () => import('@/views/device/device/Dev_Tmp.vue')
  },
  {
    path: '/Dev_Protocol',
    name: 'Dev_Protocol',
    component: () => import('@/views/device/device/Dev_Protocol.vue')
  },
  {
    path: '/Dev_PointAddr',
    name: 'Dev_PointAddr',
    component: () => import('@/views/device/device/Dev_PointAddr.vue')
  },
  {
    path: '/Dev_DevConfigDetLog',
    name: 'Dev_DevConfigDetLog',
    component: () => import('@/views/device/device/Dev_DevConfigDetLog.vue')
  },
  {
    path: '/Dev_DevConfigLog',
    name: 'Dev_DevConfigLog',
    component: () => import('@/views/device/device/Dev_DevConfigLog.vue')
  },
  //
  // ----------
  // method
  //
  {
    path: '/Video_RTSP',
    name: 'Video_RTSP',
    component: () => import('@/views/method/method/Video_RTSP.vue')
  },
  {
    path: '/MetAssetGroup',
    name: 'MetAssetGroup',
    component: () => import('@/views/method/method/MetAssetGroup.vue')
  },
  {
    path: '/MetFormConfig',
    name: 'MetFormConfig',
    component: () => import('@/views/method/method/MetFormConfig.vue')
  },
  {
    path: '/MetCompMenu',
    name: 'MetCompMenu',
    component: () => import('@/views/method/method/MetCompMenu.vue')
  },
  {
    path: '/Workbench',
    name: 'Workbench',
    component: () => import('@/views/device/DeviceMonitor/Workbench.vue')
  },
  {
    path: '/EzvCameraMonitor',
    name: 'EzvCameraMonitor',
    component: () => import('@/views/sys/ezvdevice/EzvCameraMonitor.vue'),
    meta: { title: '摄像头监控' }
  }
];

export default viewgird;
